export default __webpack_public_path__ + "static/media/SoR.47e65ecf.png";